import { userAccount } from '../Account/AccountSlice';
import { useAppSelector } from '../../../hooks';
import { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Button, Container, Row } from 'reactstrap';
import './Promotions.css';
import CustomerPromosModal from './CustomerPromosModal';
import RepPromosModal from './RepPromosModal';
import CustomerSearchModal from '../Customers/CustomerSearchModal';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../firebase';

export type Promo = {
    NAME: string;
    DESC: string;
    PROMO: string;
    "PROMO_END_DT": string;
    "PROMO_START_DT": string;
    "TOT_PTS": string;
    DOLLARS: number;
    UNITS: string;
};

const PromotionsReport = () => {
    const account = useAppSelector(userAccount);
    const branch = account.branch;
    const baseUrl = `https://customer.hirsch.com/promos/v2/branch`;
    const token = useAppSelector((state) => state.auth.token);
    const [branchPromo, setBranchPromo] = useState<Promo[]>([]);
    const [custModalOpen, setCustModalOpen] = useState<boolean>(false);
    const [custSearchOpen, setCustSearchOpen] = useState<boolean>(false);
    const [repModalOpen, setRepModalOpen] = useState<boolean>(false);
    const [pendingCustPromo, setPendingCustPromo] = useState(false);
    const [custID, setCustID] = useState<string | null>(null);

    useEffect(() => {
        getBranchPromo();
    }, []);

    const onClose = () => {
        setCustModalOpen(false);
        setRepModalOpen(false);
        setCustID(null);
    };

    const custSearchClose = (id: string | null) => {
        if (id) {
            setCustID(id);
            setCustModalOpen(true);
        }

        setCustSearchOpen(false);
    };

    const handleSearchDismiss = () => {
        if (pendingCustPromo && custID) {
            setPendingCustPromo(false);
            setCustModalOpen(true);
        }
    };
    
    const getBranchPromo = async() => {
        try {
            const response = await fetch(`${baseUrl}?all=true`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`),
                }
            });

            const json = await response.json();
            
            setBranchPromo(json.promos);
        } catch (err) {
            console.error(err);
        }
    };

    const handleRepPromo = async () => {
        setRepModalOpen(true);
        logEvent(analytics, 'rep_promos_web', {
            name: 'rep promos',
            description: 'User viewed rep promotions'
        });
    };

    const handleCustomerPromo = async () => {
        setCustSearchOpen(true);
        logEvent(analytics, 'customer_promos_web', {
            name: 'customer promos',
            description: 'User viewed customer promotions'
        });
    }

    return (
        <>
            <Container className='pt-3'>
                <Row style={{ flexDirection: 'row', justifyContent: 'space-between'}}>
                    <div style={{ flex: 1 }}>
                        <Button
                            className='tabButton bg-primary'
                            onClick={handleRepPromo}    
                        >
                            <span style={{ fontWeight: 'bold'}}>My Promos</span>
                        </Button>
                    </div>
                    <div style={{ flex: 1 }}>
                        <Button
                            className='tabButton bg-primary'
                            onClick={handleCustomerPromo}
                        >
                            <span style={{ fontWeight: 'bold'}}>Customer </span> 
                            <SearchIcon sx={{ fontSize: 16 }}/>
                        </Button>
                    </div>
                </Row>
                <Row className='py-2'>
                    <span className='headerText'>Active Promotions</span>
                </Row>
                <Container 
                    className='scrollable-container shadow'
                >
                    {branchPromo.map((promo: Promo) => (
                        <Row 
                            key={promo.PROMO}
                            className='itemContainer shadow border'
                        >
                            <span style={{ fontWeight: 'bold' }}>{promo.PROMO}</span>
                            <span>{(promo.DESC)}</span>
                            <div style={{ flexDirection: 'row', paddingTop: 10}}>
                                <span style={{ fontWeight: 'bold' }}>Start: </span>
                                <span>{promo["PROMO_START_DT"]}</span>
                            </div>
                            <div style={{ flexDirection: 'row'}}>
                                <span style={{ fontWeight: 'bold' }}>Ends: </span>
                                <span>{promo["PROMO_END_DT"]}</span>
                            </div>
                        </Row>    
                    ))}
                </Container>
            </Container>
            {custModalOpen &&
                <CustomerPromosModal 
                    visible={custModalOpen && !custSearchOpen}
                    onClose={onClose}
                    custID={custID}
                />
            }
            {custSearchOpen && 
                <CustomerSearchModal 
                    visible={custSearchOpen}
                    onClose={(id) => custSearchClose(id)}
                    onClosed={handleSearchDismiss}
                />
            }
            {repModalOpen && 
                <RepPromosModal 
                    visible={repModalOpen}
                    onClose={onClose}
                />
            }
        </>
    )
};

export default PromotionsReport;